import React, { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { useLanguage } from '../../../../contexts/LanguageContext';

const PaymentReportsFilters = ({
    filters,
    onApplyFilters,
    onReset
}) => {
    const { th } = useLanguage();
    const [filterOpen, setFilterOpen] = useState(true);
    
    // Local state - input değişikliklerini burada tutuyoruz
    const [localFilters, setLocalFilters] = useState({
        startDate: filters.startDate,
        endDate: filters.endDate,
        searchText: filters.searchText
    });

    // Reset yapıldığında local state'i de güncelle
    useEffect(() => {
        setLocalFilters({
            startDate: filters.startDate,
            endDate: filters.endDate,
            searchText: filters.searchText
        });
    }, [filters.startDate, filters.endDate, filters.searchText]);

    const toggleOpen = () => setFilterOpen((prev) => !prev);

    const handleStartDateChange = (e) => {
        setLocalFilters(prev => ({ ...prev, startDate: e.value }));
    };

    const handleEndDateChange = (e) => {
        setLocalFilters(prev => ({ ...prev, endDate: e.value }));
    };

    const handleSearchChange = (e) => {
        setLocalFilters(prev => ({ ...prev, searchText: e.target.value }));
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleApply();
        }
    };

    const handleApply = () => {
        onApplyFilters(localFilters);
    };

    const handleReset = () => {
        onReset();
    };

    return (
        <div className="generic-table-filter">
            <div className="grid">
                <div className="col-12 md:col-6 flex justify-content-start">
                    <Button 
                        icon="pi pi-filter" 
                        label={th('common.filter') || 'Filtrele'} 
                        onClick={toggleOpen} 
                        outlined={!filterOpen} 
                    />
                </div>
            </div>

            {filterOpen && (
                <div className="mt-3">
                    <Divider />
                    <div className="text-xl font-medium mb-3">
                        {th('filter.advancedFilters') || 'Filtreler'}
                    </div>

                    <div className="flex flex-wrap gap-2" style={{ alignItems: 'end' }}>
                        {/* Başlangıç Tarihi */}
                        <div className="flex-auto" style={{ minWidth: 200, maxWidth: 280 }}>
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">
                                    {th('paymentReports.filters.startDate') || 'Başlangıç Tarihi'}
                                </label>
                                <Calendar
                                    id="startDate"
                                    value={localFilters.startDate}
                                    onChange={handleStartDateChange}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    className="w-full"
                                    maxDate={localFilters.endDate}
                                    placeholder={th('common.selectDate') || 'Tarih seçin'}
                                />
                            </div>
                        </div>

                        {/* Bitiş Tarihi */}
                        <div className="flex-auto" style={{ minWidth: 200, maxWidth: 280 }}>
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">
                                    {th('paymentReports.filters.endDate') || 'Bitiş Tarihi'}
                                </label>
                                <Calendar
                                    id="endDate"
                                    value={localFilters.endDate}
                                    onChange={handleEndDateChange}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    className="w-full"
                                    minDate={localFilters.startDate}
                                    placeholder={th('common.selectDate') || 'Tarih seçin'}
                                />
                            </div>
                        </div>

                        {/* Arama */}
                        <div className="flex-auto" style={{ minWidth: 240, maxWidth: 320 }}>
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">
                                    {th('paymentReports.filters.search') || 'Ara'}
                                </label>
                                <span className="p-input-icon-left w-full">
                                    <i className="pi pi-search" />
                                    <InputText
                                        id="searchText"
                                        value={localFilters.searchText}
                                        onChange={handleSearchChange}
                                        onKeyDown={handleKeyDown}
                                        placeholder={th('paymentReports.filters.searchPlaceholder') || 'Bayi Kodu, Bayi Adı...'}
                                        className="w-full"
                                    />
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Butonlar */}
                    <div className="flex justify-content-start mt-3">
                        <Button
                            label={th('filter.reset') || 'Sıfırla'}
                            icon="pi pi-refresh"
                            className="p-button-outlined mr-2"
                            onClick={handleReset}
                        />
                        <Button
                            label={th('filter.apply') || 'Uygula'}
                            icon="pi pi-check"
                            onClick={handleApply}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default PaymentReportsFilters;
